import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Embrance the Latest Style Trends" />
      <h1 className="app__header-h1">We will style while you smile!</h1>
      <p className="p__opensans" style={{ margin: '2rem 0' }}>Indulge in Luxurious Beauty Treatments at Our Salon. Pamper Yourself with Expert Care and Unwind in a Serene Environment. Experience the Ultimate Relaxation and Rejuvenation for Your Mind and Body.</p>
      {/* <button type="button" className="custom__button">Discover our Services</button> */}
    </div>

    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header_img" />
    </div>
  </div>
);

export default Header;
